/**
 * O aviso de que o cenário da demonstração pode ter mudado do lado do servidor.
 *
 * Desde a tarefa 7, os cenários de uma vez voltam para "Registra a passagem" sozinhos depois
 * de usados. Quem usou foi uma ação (enviar, consultar); quem mostra é o seletor no topo.
 * A ação avisa, o seletor relê — sem o seletor ficar mostrando um cenário que já não vale.
 */
export const EVENTO_DO_CENARIO = "cockpit:cenario";

export function avisarQueOCenarioPodeTerMudado(): void {
  window.dispatchEvent(new Event(EVENTO_DO_CENARIO));
}
